import { ConfigurationLaboratoryResponse } from '@/modules/configurationModule/shared/services/configuration.dto'
import i18n from '@/lang/i18n'
import { CommonProtocolResponse, EnumResponse } from '@/api/services/common.dto'
import {
    ConfigurationBillableConceptResponse
} from '@/modules/configurationModule/detail/accounting/billable/concepts/services/configuration-billable-concept.dto'
import { CommonCaseTypeResponse } from '@/api/services/common/case-type/common-case-type.dto'
import { CommonSampleTypeResponse } from '@/api/services/common/sample-type/common-sample-type.dto'
import { CommonTopographicCodeResponse } from '@/api/services/common/topographic-code/common-topographic-code.dto'
import {
    CommonMostLikelyMorphologicCodeResponse
} from '@/api/services/common/most-likely-morphologic-code/common-most-likely-morphologic-code.dto'
import { CommonProcedureResponse } from '@/api/services/common/procedure/common-procedure.dto'
import { CommonAssayResponse } from '@/api/services/common/assay/common-assay.dto'
import { EntityStatusState } from '@/store/root/root-store.model'
import { Nullable } from '@/shared/types/app.types'

export enum ConfigurationAutomaticBillableConceptRuleEntityTypeId {
    CASE = 'CASE',
    SAMPLE = 'SAMPLE',
    PORTION = 'PORTION',
    SUBPORTION = 'SUBPORTION'
}

export const ConfigurationAutomaticBillableConceptRuleEntityType: { [key: string]: EntityStatusState } = {
    CASE: { code: ConfigurationAutomaticBillableConceptRuleEntityTypeId.CASE, name: i18n.tc('global.case') },
    SAMPLE: { code: ConfigurationAutomaticBillableConceptRuleEntityTypeId.SAMPLE, name: i18n.tc('global.sample') },
    PORTION: { code: ConfigurationAutomaticBillableConceptRuleEntityTypeId.PORTION, name: i18n.tc('global.portion') },
    SUBPORTION: { code: ConfigurationAutomaticBillableConceptRuleEntityTypeId.SUBPORTION, name: i18n.tc('global.subportion') }
}

export interface ConfigurationAutomaticBillableConceptRuleCreateRequest {
    entityType: string,
    conceptId: number,
    caseTypeId: Nullable<number>,
    sampleTypeId: Nullable<number>,
    topographicCodeId: Nullable<number>,
    procedureId: Nullable<number>,
    mostLikelyMorphologicCodeId: Nullable<number>,
    protocolId: Nullable<number>,
    assayId: Nullable<number>,
    rulePriority: number,
    active: boolean
}

export interface ConfigurationAutomaticBillableConceptRulePatchInBatchRequest extends Partial<ConfigurationAutomaticBillableConceptRuleCreateRequest> {
    id: number
}

export interface ConfigurationAutomaticBillableConceptRuleResponse {
    id: number
    laboratory: ConfigurationLaboratoryResponse
    entityType: EnumResponse
    concept: ConfigurationBillableConceptResponse
    caseType: CommonCaseTypeResponse
    sampleType: CommonSampleTypeResponse
    topographicCode: CommonTopographicCodeResponse
    procedure: CommonProcedureResponse
    mostLikelyMorphologicCode: CommonMostLikelyMorphologicCodeResponse
    protocol: CommonProtocolResponse
    active: boolean
    assay: CommonAssayResponse
    rulePriority: number
}
